import React from "react";
import { TwoColumnLayout } from "./framework";
import { DashboardConfigurationDialog } from "./framework/DashboardConfigurationDialog";
import LoadingOrError from "../global-layout/LoadingOrError";
import { WidgetRegistry } from "../widgets/models/WidgetRegistry";
import { ExtendsPageLayoutDto } from "./models/PageLayout";
import { PageLayoutDto } from "../generated/models";
import PageHeader from "../global-layout/PageHeader";

export interface IDashboard {
  data: PageLayoutDto | undefined;
  isLoading: boolean;
  isError: boolean;
  updatePageConfiguration: (pageConfiguration: ExtendsPageLayoutDto) => void;
}

export default function TwoColumnDashboard({
  widgetRegistry,
  dashboardProps,
  header,
  subheader,
  showDashboardHeader,
  headerComponents,
  dialogTitle,
}: {
  dashboardProps: IDashboard;
  widgetRegistry: WidgetRegistry;
  header: string;
  subheader?: string;
  showDashboardHeader: boolean;
  headerComponents?: React.ReactNode;
  dialogTitle?: string;
}) {
  const { data, isLoading, isError, updatePageConfiguration } = dashboardProps;
  const resolvedTitle =
    [dialogTitle, header, "Dashboard"].find(
      (title): title is string => Boolean(title?.trim()),
    )?.trim() ?? "Dashboard";

  if (isLoading || isError) {
    return (
      <LoadingOrError
        header={header}
        subheader={subheader}
        loading={isLoading}
        error={isError}
        message="There's a problem loading the dashboard"
        suggestions="Please try again later."
      />
    );
  }

  return (
    <>
      {showDashboardHeader && (
        <PageHeader
          header={header}
          subheader={subheader}
          headerComponents={
            <>
              {headerComponents}
              <DashboardConfigurationDialog
                pageConfiguration={data}
                setPageConfiguration={updatePageConfiguration}
                title={resolvedTitle}
              />
            </>
          }
        />
      )}
      {!showDashboardHeader && (
        <div className="flex justify-end mb-7">
          <DashboardConfigurationDialog
            pageConfiguration={data}
            setPageConfiguration={updatePageConfiguration}
            title={resolvedTitle}
          />
        </div>
      )}
      <TwoColumnLayout
        pageConfiguration={data!}
        widgetRegistry={widgetRegistry}
      />
    </>
  );
}
